<nav aria-label="breadcrumb" class="d-none d-sm-block mb-3">
  <ol class="breadcrumb bg-light rounded px-3 py-2">
    <li class="breadcrumb-item">
      <a routerLink="/dashboard">
        <i class="fa-solid fa-house me-1"></i>Inicio
      </a>
    </li>
    <ng-container *ngFor="let item of items; let last = last">
      <li
        class="breadcrumb-item"
        [class.active]="last"
        [attr.aria-current]="last ? 'page' : null"
      >
        <ng-container *ngIf="!last && item.url; else lastItem">
          <a [routerLink]="item.url">{{ item.label }}</a>
        </ng-container>
        <ng-template #lastItem>
          {{ item.label }}
        </ng-template>
      </li>
    </ng-container>
  </ol>
</nav>
